import { useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { Stack, Typography, LoadingOverlay } from '@talentmesh/core';
import { Location, Navigate, useLocation } from 'react-router';
import Page from '../../Components/Pages/Page';
import WelcomePageRulesSection from './Components/WelcomePageRulesSection';
import WelcomePageAction from './Components/WelcomePageAction';
import useTMTranslation from '../../Hooks/useTMTranslation';
import WelcomePageTestLanguageSection from './Components/WelcomePageTestLanguageSection';
import useAssessmentId from '../../Hooks/useAssessmentId';
import RoutePath from '../../Routing/RoutePath';
import { TestInfo } from '../../Models/TestInfo';
import { useLocalizationContext } from '../../Context/LocalizationContext';
import WelcomePageForm from './Components/WelcomePageForm';

export interface WelcomePageRouteState {
    activeTest?: TestInfo;
    companyName?: string;
}

function AssessmentWelcomePage(): React.JSX.Element {
    const theme = useTheme();
    const { tTest, current } = useTMTranslation();
    const { availableTestLanguage, setAvailableTestLanguage, fetchingTestLanguageOptions } = useLocalizationContext();

    const assessmentId = useAssessmentId();
    const location = useLocation() as Location<WelcomePageRouteState>;
    const activeTest = location.state?.activeTest;
    const companyName = location.state?.companyName;

    useEffect(() => {
        if (current.language) {
            setAvailableTestLanguage(assessmentId);
        }
    }, [current.language]);

    if (activeTest === undefined || companyName === undefined) {
        return <Navigate to={RoutePath.Assessments} />;
    }

    if (fetchingTestLanguageOptions || availableTestLanguage[0] === '') {
        return <LoadingOverlay />;
    }

    return (
        <WelcomePageForm activeTest={activeTest} companyName={companyName}>
            <Page containerProps={{ disableGutters: true }}>
                <Stack alignItems="center" spacing={2.5} marginTop={3.75}>
                    <Typography
                        variant="h4"
                        sx={{ textAlign: 'left', width: '100%', color: theme.palette.secondary.light }}
                    >
                        {tTest('BeforeStartingTheTestPleaseNoteTheTestLanguage')}
                    </Typography>
                    <WelcomePageTestLanguageSection availableTestLanguage={availableTestLanguage} />
                    <WelcomePageRulesSection />
                    <WelcomePageAction />
                </Stack>
            </Page>
        </WelcomePageForm>
    );
}

export default AssessmentWelcomePage;
